import React, { Component } from 'react';
import { imagePath } from '../actions/ImagePath';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';

class directCancel extends Component {
    constructor(props) {
        super(props);
        this.state = {
        }       
    }
    render() {
        return (
            <div className="bg_wrapper">
                    <ToastContainer />
                    <div className="center_tab_thanks">  
                        <img  src={imagePath("./order_cancel_FSTORE.png").default} alt="" />
                        <p className="order_msg">Your order has not been placed successfully.</p>
                       {/* <p className="order_msg">Order Id : <Link to={`/vieworder/${this.state.order_details.order_ref_no}`}> #{this.state.order_details.order_ref_no} </Link> </p> */}
                        <div className="thanks_con">Payment Failed</div>               
                    </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
      state: state.AppReducer
    }
};
  
  
export default connect(mapStateToProps)(directCancel);


